//import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isVisible: null,
},
  mutations: {
    toggleVisible(state, condicional) {
      if(condicional === false) {
        state.isVisible = false
      } else {
        state.isVisible = true
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
